<div id="error" class="flex-column">
  <h1>404</h1>
  <h4>Oops! You're lost.</h4>
  <p>The page you are looking for was not found.</p>
</div>